/**
 * @file
 * A JavaScript file for Anchor Platform booking interaction.
 *
 */

"use strict";

(function($, Drupal) {
	$(document).ready(function() {
		transactionStatus()
		formErrorChecking()
		// disableInttraDelete()
		inttraOffIfClientRequest()
		amendmentJustification()
		amendmentJustificationSwitch()
		closeErrorModal()
		resendRequired()
	});

	Drupal.behaviors.hideInttraRefrigeration = {
		attach: function (context, settings) {
			// Hide the refrigeration fields on the Field collection
			var $containerWrapper = $('.field-name-field-anchor-equipmentdetails.field-widget-field-collection-embed table.field-multiple-table tbody > tr.draggable')

			if ($containerWrapper.length) {
				$containerWrapper.once('hideInttraRefrigeration', function(index) {
					var $toHide = $(`
										div[id*="-field-anchor-edequipmenttemperav"],
										div[id*="-field-anchor-edventsetting"],
										div[id*="-field-anchor-edequipmentairflowv"],
										div[id*="-field-anchor-edtempcontr"]
									`, this)

					var $select = $('select[id*="field-anchor-equipmenttypecode"]', this)

					// On collection load
					var inttraRFHide = $('#inttra-container-' + $(this)[0].rowIndex)
					$select.val().indexOf('RT') > 0 ? $toHide.show() : $toHide.hide()
					$select.val().indexOf('RT') > 0 ? inttraRFHide.find('.inttra-rf').show() : inttraRFHide.find('.inttra-rf').hide()

					// On Select change
					$select.change( function() {
						if ( $(this).val().indexOf('RT') > 0 ) {
							$toHide.slideDown()
							inttraRFHide.find('.inttra-rf').show()
						} else {
							$toHide.slideUp()
							inttraRFHide.find('.inttra-rf').hide()

							// Reset all inputs at once
							$('input', $toHide).attr('checked', false).val('')
						}
					})
				})
			}
		}
	}

	function resendRequired() {
		if ( $('#edit-field-inttra-resend-required-und').length ) {
			$('#edit-field-inttra-resend-required-und').prop('checked', true);

			$('#edit-field-inttra-resend-required-und').change(() => {
				console.log(document.getElementById('resend-required').dataset.status, $('#edit-field-inttra-resend-required-und')[0].checked)
				if( $('#edit-field-inttra-resend-required-und')[0].checked ) {
					$('#edit-field-inttra-transactionstatus-und').val('NeedsReSend')
				} else {					
					$('#edit-field-inttra-transactionstatus-und').val(document.getElementById('resend-required').dataset.status)
				}
			})
			
		}
	}

	function transactionStatus() {
		if ( $('#edit-transaction-status').length ) {
			let statusCheckboxes = document.querySelectorAll("input[name='field_anchor_transactionstatus[und]']")
			let anchorStatus = ''
			let inttraStatus = ''
			let sentAlready  = document.getElementById('edit-field-send-to-inttra-und').checked

			Object.entries(statusCheckboxes).forEach(([i, el]) => {
				if (el.checked ) {
					anchorStatus = el.value
				}
			})
			
			if( $('.dummy-inttra-response').length ) {
				if ( $('.dummy-inttra-response').hasClass('AwaitingResponse') ) {
					inttraStatus = 'AwaitingResponse'
				}

				if ( $('.dummy-inttra-response').hasClass('ConditionallyAccepted') ) {
					inttraStatus = 'ConditionallyAccepted'
				}

				if ( $('.dummy-inttra-response').hasClass('Confirmed') ) {
					inttraStatus = 'Confirmed'
				}

				if ( $('.dummy-inttra-response').hasClass('Pending') ) {
					inttraStatus = 'Pending'
				}
			}
			
			if ( inttraStatus === "AwaitingResponse" ) {
				$('#edit-transaction-status').hide()
			} else if ( anchorStatus === "Original" && !sentAlready ) {
				$('label[for="edit-field-anchor-transactionstatus-und-change"').parent().hide()
				$('label[for="edit-field-anchor-transactionstatus-und-cancel"').parent().hide()
			} else if ( sentAlready ) {
				$('label[for="edit-field-anchor-transactionstatus-und-original"').parent().hide()
				$('label[for="edit-field-anchor-transactionstatus-und-change"').click()
			}

			// Change to resend if needed
			// if ( inttraStatus === "AwaitingResponse" || inttraStatus === "ConditionallyAccepted" || inttraStatus === "Confirmed" || inttraStatus === "Pending" ) {
			// 	document.getElementById('edit-field-inttra-transactionstatus-und').value = 'NeedsReSend'
			// }


			// if (anchorStatus === "Change") {
			// 	$('label[for="edit-field-anchor-transactionstatus-und-original"').parent().hide()
			// } else if (anchorStatus === "Cancel") {
			// 	$('label[for="edit-field-anchor-transactionstatus-und-change"').parent().hide()
			// }

			// if ( sentAlready ) {
			// 	$('label[for="edit-field-anchor-transactionstatus-und-original"').parent().hide()
			// 	$('label[for="edit-field-anchor-transactionstatus-und-change"').click()
			// }
		}
	}

	function formErrorChecking() {
		if ( $('#edit-submit--2').length ) {
			var moment = require('moment');

			// on click submit, check if the POL date is before the POD date
			$('#edit-submit--2, #edit-submit--3, .btn.event-save-send').click( (e) => {
				// Check the dates
				let pol1stop 	 = document.getElementById('edit-field-etd-und-0-value').value
				let manualDate	 = document.getElementById('edit-field-manual-etd-und-0-value-datepicker-popup-0').value
				let manualTime	 = document.getElementById('edit-field-manual-etd-und-0-value--popup-1').value
				let podDate		 = document.getElementById('edit-field-eta-pod-und-0-value-datepicker-popup-0').value
				let podTime		 = document.getElementById('edit-field-eta-pod-und-0-value--popup-1').value
				let manual 		 = ''
				let pod 		 = ''
				let allowSubmit  = false
				
				if ( pol1stop != '' ) {
					pol1stop = moment(pol1stop, 'DD/MM/YYYY HH:mm')
					if ( podDate != '' && podTime != '' ) {
						pod = moment(podDate + ' ' + podTime, 'DD/MM/YYYY HH:mm')

						if ( moment(pol1stop).isBefore(pod) ) {
							allowSubmit = true
						}
					}
				} else if ( manualDate != '' && manualTime != '' ) {
					manual = moment(manualDate + ' ' + manualTime, 'DD/MM/YYYY HH:mm')
					if ( podDate != '' && podTime != '' ) {
						pod = moment(podDate + ' ' + podTime, 'DD/MM/YYYY HH:mm')

						if ( moment(manual).isBefore(pod) ) {
							allowSubmit = true
						}
					}
				}

				// Check the haulage arrangements
				let edhaulagearrangement = document.querySelectorAll('select[name$="[field_anchor_edhaulagearrangemen][und]"]')
				let value = edhaulagearrangement[0].value
				let allowHaulage = true
				Object.entries(edhaulagearrangement).forEach(([i, el]) => {
					if ( el.value != value ) {
						allowHaulage = false
					}
				})

				// Check if fieds are filled when cancel booking
				let val = getSafe(() => document.querySelectorAll('input[name="field_anchor_transactionstatus[und]"]:checked')[0].value)
				let cancel_message = getSafe(() => document.getElementById('edit-field-reason-for-cancellation-und-0-value').value)
				let cancel_email = getSafe(() => document.getElementById('edit-field-shipping-line-contact-emai-und-0-value').value)
				// let val = document.querySelectorAll('input[name="field_anchor_transactionstatus[und]"]:checked')[0].value
				// let cancel_message = document.getElementById('edit-field-reason-for-cancellation-und-0-value').value
				// let cancel_email = document.getElementById('edit-field-shipping-line-contact-emai-und-0-value').value
				let allowCancel = true
				let emailValid = true

				if ( val == "Cancel" ) {
					allowCancel = false
					// emailValid = false

					if ( cancel_message != '' ) {
						allowCancel = true
					}

					if ( cancel_email != '' && emailIsValid(cancel_email) ) {
						emailValid = true
					}
				} 

				// Create the message
				let errorMessage = ''
			
				if ( !allowSubmit ) {
					errorMessage += 'Please ensure that POL date and POD date are filled in, and that the POL date is before the POD Date.<br>'
				}

				if ( !allowHaulage ) {
					errorMessage += 'Container Haulage Arrangement Code must be same for all Equipment Groups provided in the Booking transaction.<br>'
				}

				if ( !allowCancel ) {
					errorMessage += 'You must provide a reason for cancelling.<br>'
				}

				if ( !emailValid ) {
					errorMessage += 'You must provide a valid email address for the shipping line contact.<br>'
				}

				if ( !allowSubmit || !allowHaulage || !allowCancel || !emailValid ) {
					e.preventDefault()
					
					if ( $('#anchorModal').length ) {
						$('#anchorModal .modal-content').addClass('messages error')
						$('#anchorModal .modal-content').empty()
						$('#anchorModal .modal-content').html('<p>' + errorMessage + '</p>')
					} else if ( $('#messageModal').length ) {
						$('#messageModal .modal-content').addClass('messages error')
						$('#messageModal .modal-content').empty()
						$('#messageModal .modal-content').html('<p>' + errorMessage + '</p>')
					}
					document.body.classList.add('modal-open')
				}
			})

		}
	}

	function emailIsValid (email) {
		return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
	}

	function disableInttraDelete() {
		if ( $('#edit-submit--2').length ) {
			const btnDel = document.getElementById('edit-delete--2')
			const btnDe2 = document.getElementById('edit-delete--3')
			const useInt = document.getElementById('edit-field-use-inttra-und')
			const sentTo = document.getElementById('edit-field-send-to-inttra-und').checked

			if ( sentTo ) {
				btnDel.classList.add('disabled')
				btnDe2.classList.add('disabled')
				useInt.classList.add('disabled')
				useInt.checked = true
				btnDel.disabled = true
				useInt.disabled = true
			}
		}
	}

	function inttraOffIfClientRequest() {
		if( typeof is_anchor_user !== 'undefined' && is_anchor_user == '0' && $('input#edit-field-use-inttra-und').length ) {
			const useInt = document.getElementById('edit-field-use-inttra-und')
			useInt.checked = false
		}
	}

	function amendmentJustification() {
		if ( $('#edit-amendment-justification').length ) {
			const trigger = document.querySelectorAll('input[name="field_anchor_transactionstatus[und]"]')
			
			$(trigger).on('change', (e) => {
				amendmentJustificationSwitch()
			})
		}

		// limit length
		const limit = document.getElementById('edit-field-anchor-ajtext-und-0-value')
		const notes = document.getElementById('edit-field-booking-notes-und-0-value')
		const cancel = document.getElementById('edit-field-reason-for-cancellation-und-0-value')
		limitLength1024(limit)
		limitLength1024(notes)
		limitLength1024(cancel)
		
	}

	function amendmentJustificationSwitch() {
		if ( $('#edit-amendment-justification').length ) {
			const amend_textarea = document.getElementById('edit-amendment-justification')
			const cancel_textarea = document.getElementById('edit-reason-for-cancellation')
			const cancel_email = document.getElementById('edit-sl-contact')
			let val = getSafe(() => document.querySelectorAll('input[name="field_anchor_transactionstatus[und]"]:checked')[0].value)

			if ( val == "Change" ) {
				amend_textarea.classList.add('show')
			} else {
				amend_textarea.classList.remove('show')
			}

			if ( val == "Cancel" ) {
				cancel_textarea.classList.add('show')
				cancel_email.classList.add('show')
			} else {
				cancel_textarea.classList.remove('show')
				cancel_email.classList.remove('show')
			}
		}
	}

	function limitLength1024(node) {
		$(node).on('keyup', (e) => {
			if ( e.currentTarget.textLength >= 1024 ) {
				e.currentTarget.value = e.currentTarget.value .substr(0, 1024)
				e.currentTarget.classList.add('error')
			} else {
				e.currentTarget.classList.remove('error')
			}
		})
	}

	function closeErrorModal() {
		$('#noEditModal, #noEditModal .modal-close').click( () => {
			$('.modal').removeClass('open')
		})
	}

	function getSafe(fn, defaultVal) {
    try {
        return fn();
    } catch (e) {
        return defaultVal;
    }
	}


})(jQuery, Drupal)